import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import ScreeningTable from "./ApplicantTableComponent/ScreeningTable";
import swal from "sweetalert";

const ApplicantScreening = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "SCREENING" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);



  useEffect(() => {
    const input = { applicationStatus: "SCREENING" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch]);


  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])

  return (
    <div>
      <ScreeningTable
        statusButton={"view-job-status"}
        pageHeader={"Screening"}
        Status={"Screening Awaited"}
        headerTitles={[
          "",
          "Edit",
          "Update",
          "Title",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Job Profile",
          "View ID",
          "Applied On",
          "Status",
          "Phone Number",
          "Stage",
          "Work Experience",
          "Email",
          "Location",
          "Edit",
        ]}
        data={data}
        message={message}
        isError={isError}
        isLoading={isLoading} 
        setResetID={setResetID}      />
    </div>
  );
};

export default ApplicantScreening;
